import * as TYPES from "./types";
import { detect } from 'detect-browser';

export function loadCommonInfo(successFn = null, errorFn = null) {

    return dispatch => {
        const browserDetails = detect();
        const browser = {...browserDetails, isIE: browserDetails.name === 'ie'};
        dispatch({ type: TYPES.INFO_SET, payload: {browser: browser} });
        dispatch({ type: TYPES.INFO_LOADED, payload: {loaded: true}});
    };
}

export function setRefresh(refreshing = false) {
    return dispatch => {
        dispatch({ type: TYPES.INFO_REFRESH, refreshing});
    };
}

